module.exports = __webpack_public_path__ + "static/media/IST_C_POS_S.e04aefd1.png";